import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography, CircularProgress, Card } from "@mui/material";

import ViewDetailsBtn from "../ViewDetailsBtn/ViewDetailsBtn";
import analyticsService from "../../../../services/analyticsService";
import config from "../../../../config";
import { getDateRangeFromFilter } from "../../../../utils/dateFilterUtils";

const HighClicksLowConversions = ({ dateFilterValue }) => {
  const [productsData, setProductsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const dateRange = getDateRangeFromFilter(dateFilterValue);
        const response = await analyticsService.getHighClicksLowConversions(
          config.clientId,
          5,
          dateRange.start_date,
          dateRange.end_date
        );

        if (response.success && response.data) {
          setProductsData(response.data);
        } else {
          setError(response.message || "Failed to fetch data");
        }
      } catch (err) {
        console.error("Error fetching high clicks low conversions:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (config.clientId) {
      fetchData();
    }
  }, [dateFilterValue]);

  const chartState = {
    series: [{ data: productsData.map((d) => d.conversion_rate) }],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: false },
        fontFamily: "Inter, sans-serif",
      },
      plotOptions: {
        bar: {
          borderRadius: 6,
          horizontal: true,
          endingShape: "rounded",
        },
      },
      dataLabels: { enabled: false },
      colors: ["#6f42c1"],
      xaxis: {
        categories: productsData.map((d) => d.product_name),
        labels: { style: { colors: "#495057", fontSize: "14px" } },
      },
      yaxis: {
        labels: { style: { colors: "#495057", fontSize: "14px" } },
      },
      tooltip: { theme: "dark" },
      grid: {
        show: true,
        borderColor: "#e9ecef",
        row: { colors: ["transparent"], opacity: 0.5 },
      },
    },
  };

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        paddingTop: "10px",
        paddingLeft: "0px",
        paddingRight: "0px",
        paddingBottom: "0px",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" px={2} mb={"4px"}>
        <Typography variant="h6" fontWeight="bold" sx={{ color: "#6D5DD2", flexGrow: 1, whiteSpace: "nowrap" }}>
          High Clicks, Low Conversions
        </Typography>

        <ViewDetailsBtn
          redirectTo="/analytics/high-clicks/details"
          align="right"
          dateFilterValue={dateFilterValue}
        />
      </Box>

      {/* Chart */}
      <Box px={2}>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height={350}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box display="flex" justifyContent="center" alignItems="center" height={350}>
            <Typography color="error">{error}</Typography>
          </Box>
        ) : productsData.length > 0 ? (
          <ReactApexChart
            options={chartState.options}
            series={chartState.series}
            type="bar"
            height={350}
          />
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height={350}>
            <Typography>No data available</Typography>
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default HighClicksLowConversions;


// HighClicksLowConversiond.js
// import React from "react";
// import { useState } from "react";
// import ReactApexChart from "react-apexcharts";

// const HighClicksLowConversions = () => {
//   const [state, setState] = React.useState({
//     series: [
//       {
//         data: [350, 300, 248, 200, 140],
//       },
//     ],
//     options: {
//       chart: {
//         type: "bar",
//         height: 350,
//       },
//       plotOptions: {
//         bar: {
//           borderRadius: 4,
//           borderRadiusApplication: "end",
//           horizontal: true,
//         },
//       },
//        colors: ["#FF0000"],
//       dataLabels: {
//         enabled: false,
//       },
//       xaxis: {
//         categories: [
//           // "South Korea",
//           // "Canada",
//           // "United Kingdom",
//           // "Netherlands",
//           // "Italy",
//           "Mystery Box",
//           "High Potency Oil",
//           "Sample Pack",
//           "Merch Hoodie",
//           "Bath Bomb",
//         ],
//       },
//     },
//   });

//   return (
//     <div>
//         <h3>High Clicks, Low Conversions</h3>
//       <div id="chart">
//         <ReactApexChart
//           options={state.options}
//           series={state.series}
//           type="bar"
//           height={350}
//         />
//       </div>
//     </div>
//   );
// };

// export default HighClicksLowConversions;


/////////////////////////////////////////////////////////////////////////////////////////
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import ReactApexChart from "react-apexcharts";
// import { Box, Button, Typography } from "@mui/material";

// const HighClicksLowConversions = () => {
//   const navigate = useNavigate();

//   const chartState = {
//     series: [
//       { data: [350, 300, 248, 200, 140] },
//     ],
//     options: {
//       chart: { type: "bar", height: 350 },
//       plotOptions: { bar: { borderRadius: 4, borderRadiusApplication: "end", horizontal: true } },
//       colors: ["#FF0000"],
//       dataLabels: { enabled: false },
//       xaxis: {
//         categories: ["Mystery Box", "High Potency Oil", "Sample Pack", "Merch Hoodie", "Bath Bomb"],
//       },
//     },
//   };

//   return (
//     <Box p={3}>
//       {/* Header with title and button */}
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h6" fontWeight="600">
//           High Clicks, Low Conversions
//         </Typography>

//         <Button
//           variant="contained"
//           size="small"
//           onClick={() => navigate("/analytics/high-clicks/details")}
//           sx={{ borderRadius: "8px", textTransform: "none" }}
//         >
//           View Details →
//         </Button>
//       </Box>

//       {/* Chart */}
//       <ReactApexChart
//         options={chartState.options}
//         series={chartState.series}
//         type="bar"
//         height={350}
//       />
//     </Box>
//   );
// };

// export default HighClicksLowConversions;


// import React from "react";
// import { useNavigate } from "react-router-dom";
// import ReactApexChart from "react-apexcharts";
// import { Box, Button, Typography } from "@mui/material";

// const HighClicksLowConversions = () => {
//   const navigate = useNavigate();

//   const chartState = {
//     series: [
//       { data: [350, 300, 248, 200, 140] },
//     ],
//     options: {
//       chart: {
//         type: "bar",
//         height: 350,
//         toolbar: { show: false },
//         fontFamily: 'Inter, sans-serif',
//       },
//       plotOptions: {
//         bar: {
//           borderRadius: 6,
//           horizontal: true,
//           distributed: false,
//           endingShape: "rounded",
//         },
//       },
//       dataLabels: { enabled: false },
//       colors: ["#6f42c1"], // Trezo purple
//       xaxis: {
//         categories: ["Mystery Box", "High Potency Oil", "Sample Pack", "Merch Hoodie", "Bath Bomb"],
//         labels: { style: { colors: "#495057", fontSize: '14px' } },
//       },
//       yaxis: {
//         labels: { style: { colors: "#495057", fontSize: '14px' } },
//       },
//       tooltip: { theme: 'dark' },
//       grid: {
//         show: true,
//         borderColor: "#e9ecef",
//         row: { colors: ["transparent"], opacity: 0.5 },
//       },
//     },
//   };

//   return (
//     <Box p={3}>
//       {/* Header with title and button */}
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h6" fontWeight="600">
//           High Clicks, Low Conversions
//         </Typography>

//         <Button
//           variant="contained"
//           size="small"
//           onClick={() => navigate("/analytics/high-clicks/details")}
//           sx={{ borderRadius: "8px", textTransform: "none" }}
//         >
//           View Details →
//         </Button>
//       </Box>

//       {/* Chart */}
//       <ReactApexChart
//         options={chartState.options}
//         series={chartState.series}
//         type="bar"
//         height={350}
//       />
//     </Box>
//   );
// };

// export default HighClicksLowConversions;
